import Validation from "./index";
import getValidation from "./getValidation";
var default_1 = /** @class */ (function () {
    function default_1(component) {
        this.component = component;
        this.validator = {
            validate: this.validate.bind(component)
        };
        Validation.add(this.validator);
    }
    default_1.prototype.validate = function (currentScreen) {
        // This function is bound to the component in the constructor so it can modify stuff
        var component = this;
        var validation = getValidation(component);
        if (validation) {
            if (!currentScreen || currentScreen === component.context.currentScreen) {
                return validation
                    .validate(component.state.value)
                    .then(function () {
                    component.setState({ errorMsg: null });
                })
                    .catch(function (err) {
                    component.setState({ errorMsg: err.errors[0] });
                    throw new Error("Validation Error: " + err.errors[0]);
                });
            }
        }
        return null;
    };
    default_1.prototype.update = function (prevProps, prevState) {
        var _this = this;
        if (prevState === void 0) { prevState = {}; }
        if (this.component.state.value !== prevState.value) {
            var validation = this.validator.validate();
            if (validation) {
                validation.catch(function (err) {
                    var _a = _this.component, props = _a.props, state = _a.state;
                    console.log(err.message + " (field: '" + props.name + "', value: '" + state.value + "')");
                });
            }
        }
    };
    default_1.prototype.destroy = function () {
        Validation.remove(this.validator);
    };
    return default_1;
}());
export default default_1;
